/**
 * composantes variés dans le formulaire de réservation, excluant les conteneurs d'étapes et les questions de
 * formulaire (voir plus bas)
 */
export const BUTTON_SUBMIT = 'button-form-submit';
export const BUTTON_VALIDATE = 'button-form-validate';
export const ROUTER_LINK_CUSTOMER_HOME = 'router-link-customer-home';
/** Lien "précédent */
export const BUTTON_LINK_BACK = 'button-form-link-back';
export const BUTTON_LINK_CANCEL_MODIFICATION = 'button-form-link-cancel-modification';
export const BOOKING_REQUEST_BUTTON_DATED = 'booking-request-dated-button';
export const BOOKING_REQUEST_BUTTON_TEMPLATE = 'booking-request-regular-button';
export const BOOKING_FORM_CONTAINER_DATED = 'booking-form-container-dated';
export const BOOKING_FORM_CONTAINER_TEMPLATE = 'booking-form-container-template';
/** Formulaire de changement d'heure, disponible lors d'une erreur à la fin du formulaire de réservation occasionnel. */
export const BOOKING_FORM_TIME_CHANGE = 'booking-form-time-change';
export const ACTION_CONFIRMATION_MODAL = 'time-change-modal';
/**
 * Conteneur pour l'affichage conditionnel d'un élément, généralement lorsqu'il s'agit d'un déplacement de type
 * "aller-retour"
 */
export const ROUNDTRIP_CONDITIONAL_ITEM = 'booking-form-conditional-item';
/** Boîte de statut en lien avec la restriction de certaines dates (ou toutes les dates) */
export const DATE_RESTRICTIONS_STATUS_BOX = 'booking-form-date-restrictions-status-box';

/* Les différentes étapes définies pour les formulaires de réservation de type occasionnelle ou régulier */
export const FORM_STEP_ONE = 'form-step-one';
export const FORM_STEP_ADDRESS = 'form-step-address';
export const FORM_STEP_TIME = 'form-step-time';
export const FORM_STEP_ASSISTIVE_DEVICES = 'form-step-assistive-devices';
export const FORM_STEP_COMPANIONS = 'form-step-companions';
export const FORM_STEP_REVIEW = 'form-step-review';
export const FORM_SUBMISSION_PAGE = 'form-submission-page';

export const ITEM_ADDRESS_RECENT_TAB_PANEL = 'form-item-recent-tab-panel';
export const ITEM_ADDRESS_FAVOURITE_TAB_PANEL = 'form-item-favourite-tab-panel';
export const ITEM_ADDRESS_PUBLIC_TAB_PANEL = 'form-item-public-tab-panel';

/* Les différents éléments (questions) du formulaire */
export const ITEM_DATE_SELECTOR = 'form-item-date';
export const ITEM_TRIP_TYPE = 'form-trip-type-selector';
export const ITEM_COMPANIONS = 'form-item-companions';
export const ITEM_COMPANIONS_NONE = 'form-item-companions-none';
export const ITEM_COMPANIONS_DEVICES = 'form-item-companions-devices';
export const ITEM_COMPANIONS_MODIFICATION_DEVICE = 'companions-modification-device';
export const ITEM_ASSISTIVE_DEVICES = 'form-item_assistive-devices';
export const ITEM_ADDRESS = 'form-item-address';
export const ITEM_ADDRESS_CATEGORY_BUTTONS = 'form-item-address-categories';
export const ITEM_ADDRESS_APARTMENT = 'form-item-apartment';
export const ITEM_ADDRESS_SELECTED = 'form-item-address-selected';
export const ITEM_ADDRESS_MODAL = 'form-item-address-modal';
export const ITEM_TIME_SELECTOR = 'form-item-time-selector';
export const ITEM_TIME_RESTRICTION = 'form-item-time-restriction';
export const ITEM_TIME_INPUT_FIELD = 'form-item-time-input-field';
export const ITEM_FREQUENCY_TYPE = 'form-item-trip-frequency';
export const ITEM_DAYS_OF_WEEK = 'form-item-days-of-week';
export const ITEM_DATE_RANGE = 'form-item-date-range';
export const STEP_REVIEW_COMPANIONS_LIST = 'step-review-companions';
export const STEP_REVIEW_TIME = 'step-review-time';
export const STEP_REVIEW_COMPANION_DEVICES = 'companion-devices';
export const STEP_REVIEW_DEVICES = 'step-review-devices';

export const tripBookingModals = {
  ['DATE_RANGE_CONTENT_dateRange.startDate']: 'template-date-range-start-content',
  ['DATE_RANGE_CONTENT_dateRange.endDate']: 'template-date-range-end-content',
  LEAVING_CONFIRMATION_REQUEST: 'leaving-confirmation-request',
};

export const statusBoxes = {
  STEP_VALIDATION_PROBLEM: 'booking-step-validation-error',
  FORM_SUBMISSION_DATED: 'booking-submission-dated',
  FORM_SUBMISSION_TEMPLATE: 'booking-submission-success-template',
  CANCELLATION_ERROR: 'booking-cancel-confirmed-time',
  FORM_COMPANIONS_MANDATORY: 'booking-form-companions-mandatory',
};
